"use client"
import React, {useState} from 'react';
import {Col, Container, Form, Row} from 'react-bootstrap';
import styled from 'styled-components';
import SelectField from "@/components/common/SelectField";
import {hardGray, hover, softWhite, text, white} from "@/styles/globalStyleVars";
import {useForm} from "react-hook-form";
import Button from "@/components/common/ui/Button";
import reactHtmlParser from "react-html-parser";
import {getCourse, getSearchCourse} from "@/api";
import SearchIcon from "@/components/common/ui/icons/SearchIcon";

/**
 * Overview Type 6 component section
 * Pass the props with your data to the Overview Type 6 component.
 * Check the page folder to see the components used.
 **/
const VersityList = ({data, id, offset}) => {


    const dispath = null;
    const [selectedData, setSelectedData] = useState(data?.data);
    const [selectedCountry, setSelectedCountry] = useState('');
    const [disableCourse, setDisableCourse] = useState(true);


    let countryArray = data?.filter?.country
    let studyArray = data?.filter?.study

    let countryOptions = [];
    let studyOptions = [];


    // Check if universityArray is defined and not empty
    if (countryArray && countryArray.length > 0) {
        countryOptions = countryArray.map(e => ({
            value: e?.category_data?.id,
            label: reactHtmlParser(e?.category_data?.title)
        }));
    }

    // Check if universityArray is defined and not empty
    if (studyArray && studyArray.length > 0) {
        studyOptions = studyArray.map(e => ({
            value: e?.category_data?.id,
            label: reactHtmlParser(e?.category_data?.title)
        }));
    }



    const handleClickCountry = async (country ) => {
        try {
            const getHomeData = await getCourse(country?.value,'');
            setSelectedData(getHomeData?.data)
            setDisableCourse(false);
            setSelectedCountry(country?.value)
        } catch (error) {

        }
    };



    const handleClickStudy = async (country ) => {
        try {
            const getHomeData = await getCourse(selectedCountry,country?.value);
            setSelectedData(getHomeData?.data)

        } catch (error) {

        }

    };


    const { register, handleSubmit, formState, setValue } = useForm();

    // Method to call on typing
    const handleTyping = async (e) => {
        const searchTerm = e.target.value;
        try {
            if(searchTerm){
                const getHomeData = await getSearchCourse(searchTerm);
                setSelectedData(getHomeData?.data)
            }else{
                const getHomeData = await getCourse('','');
                setSelectedData(getHomeData?.data)
            }


        } catch (error) {

        }
    };

    // Method to call on form submission (Enter key)
    const onSubmit = async (data) => {

        const searchTerm = data?.search;
        try {
            if (searchTerm) {
                const getHomeData = await getSearchCourse(searchTerm);
                setSelectedData(getHomeData?.data)
            } else {
                const getHomeData = await getCourse('', '');
                setSelectedData(getHomeData?.data)
            }


        } catch (error) {

        }
    };











    const options = [
        {value: '', label: 'All'}
    ];


    const mergedOptions = options.concat(countryOptions?.map(item => ({
        value: item.value,
        label: item.label
    })));



    return (
        <StyledOverview6 id={id} offset={offset} className={'ministry '}>
            <Container>
                <Row className={'filter-wrapper'}>
                    <Col md={4} className={'filter '}>
                        <SelectField selection={mergedOptions} onChange={handleClickCountry} background={'transparent'} color={'#888888'} border={'#888888'} placeholder={'All'}/>
                    </Col>
                    <Col md={4} className={'filter'}>
                        <SelectField selection={studyOptions}  background={'transparent'} color={'#888888'} border={'#888888'} placeholder={'Select Field of Study'} disabled={disableCourse ? true : false} onChange={handleClickStudy}/>
                    </Col>
                    <Col md={4} className={'filter filter_search'}>
                        <Form onSubmit={handleSubmit(onSubmit)}>
                            <Form.Group className={'form-group'} controlId="formBasicSearch">
                                <SearchIcon/>

                                <Form.Control
                                    className={formState?.errors?.search?.message ? 'has-error form-control-lg' : 'form-control-lg'}
                                    {...register('search', {
                                        required: {
                                            value: true, message: 'Please enter a search term'
                                        }
                                    })}
                                    type="text"
                                    placeholder="Find a course"
                                    onChange={handleTyping}
                                    onInput={handleTyping}
                                    onKeyPress={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            handleSubmit(onSubmit)();
                                        }
                                    }}
                                />
                                {formState.errors.search && <p className="error-message">{formState.errors.search.message}</p>}
                            </Form.Group>
                        </Form>
                    </Col>
                </Row>
                <Row className={'versity-list-row'}>

                    {
                        selectedData && selectedData?.length > 0 ?
                        selectedData?.map((e, index) => {

                            return (
                                <Col key={index} md={12}>
                                    <div className="single-item align-items-center d-flex justify-content-between flex-wrap">
                                        <div className="title ">
                                            <h6>{reactHtmlParser(e?.data?.title)}</h6>
                                        </div>
                                        <div className="country title-width">
                                            {
                                                e?.country?.title &&
                                                <p><span>Country:</span> {e?.country?.title}</p>

                                            }
                                            {
                                                e?.study?.title &&
                                                <p><span>Field of Study:</span> {reactHtmlParser(e?.study?.title)}</p>

                                            }
                                        </div>
                                        <div className="button">
                                            <Button src={`/courses/${e?.data?.slug}`} text={'Check Details'} height={40}/>
                                        </div>
                                    </div>
                                </Col>

                            );
                        }) :

                            <Col md={12}>
                                <h4>No Course Found</h4>
                            </Col>
                    }

                </Row>
            </Container>
        </StyledOverview6>
    );
};

/**
 * Styled component for Overview Type 6 component section
 * Add your custom styles for this component
 **/
const StyledOverview6 = styled.section`
    position: relative;
    padding-top: 80px;
    padding-bottom: 200px;
    background: ${softWhite};

    .form-control.has-error {
        border-color: transparent !important;
    }

    .filter_search {
        position: relative;

        svg {
            position: absolute;
            top: 18px;
            left: 25px;
        }

        .form-control {
            margin: 0;
            padding: 0 25px 0 50px;
            background-color: ${hardGray} !important;
            height: 50px;
            border-radius: 100px;
            font-size: 16px;
            line-height: 24px;
            letter-spacing: -0.16px;
            font-weight: 400;
            color: white;

            &::placeholder {
                font-size: 16px;
                line-height: 24px;
                letter-spacing: -0.16px;
                font-weight: 400;
                color: white;
            }

        }
    }

    h2 {
        margin-bottom: 40px;

        span {
            color: ${hover}
        }
    }


    .filter-wrapper {
        padding-bottom: 60px;

        .filter--is-disabled {
            .filter__control {
                border: 1px solid transparent;

            }

            .filter__placeholder {
                color: ${hardGray};
            }

            .filter__indicator svg line {
                stroke: rgb(4, 5, 4) !important;
            }
        }

        .filter__control {
            border: 1px solid ${hardGray};
            max-width: 100%;
            background: ${white};
        }

        .filter__placeholder {
            color: ${text};
            font-size: 16px;
            line-height: 24px;
            letter-spacing: -0.16px;
            font-weight: 400;
        }

        .filter__single-value {
            font-size: 16px;
            line-height: 24px;
            letter-spacing: -0.16px;
            font-weight: 400;
            color: ${text};

        }


        @media (max-width: 992px) {
            .col-md-4.filter {
                margin-bottom: 30px;
                flex: 0 0 100%;
                max-width: 100%;

                &:last-child {
                    margin-bottom: 0;
                }
            }
        }
    }

    .versity-list-row {
        display: flex;
        flex-wrap: wrap;
        margin: -15px; /* Adjust for negative margins */

        .col-md-12 {
            margin: 15px; /* Adjust for negative margins */
            padding-left: 0;
            padding-right: 0;

            &:last-child {
                .single-item {
                    margin-bottom: 0;
                    padding-bottom: 0;
                    border-bottom: 0;
                }
            }
        }

        .single-item {
            padding-bottom: 40px;
            margin-bottom: 40px;
            border-bottom: 1px solid rgba(54, 50, 49, 0.1);

            .title {
                flex: 0 0 33.333%;
                max-width: 33.333%;

                h6 {
                    font-size: 20px;
                    letter-spacing: -0.2px;
                    line-height: 28px;
                    font-weight: 500;
                }
            }

            .country {
                span {
                    color: ${hardGray};
                }
            }
        }

        @media (max-width: 992px) {
            padding-bottom: 40px;
            margin-bottom: 40px;
            .single-item {
                align-items: flex-start !important;
                flex-direction: column;
                .title{
                    margin-bottom: 25px;
                    flex: 0 0 100%;
                    max-width: 100%;
                }
                .country{
                    margin-bottom: 25px;
                }
            }
        }
    }
    
    @media(min-width: 1024px){
        .title-width{
            max-width: 25%;
            flex: 0 0 25%;
        }
    }

`;

export default React.memo(VersityList);
